import React from 'react';
import { AlertCircle, Sparkles } from 'lucide-react';
export function TopBanner() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-orange-500 via-orange-400 to-orange-500 text-white py-2 px-4 shadow-md border-b-4 border-orange-600" data-id="element-333">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center text-center gap-2 md:gap-4 text-sm md:text-base" data-id="element-334">
        <div className="flex items-center gap-2 font-bold animate-pulse bg-white/20 px-3 py-1 rounded-full" data-id="element-335">
          <Sparkles className="w-4 h-4 text-yellow-200" data-id="element-336" />
          <span className="uppercase tracking-wide text-white text-xs md:text-sm" data-id="element-337">
            ¡Oferta Especial!
          </span>
        </div>
        <p className="font-bold text-white drop-shadow-sm" data-id="element-338">
          ¿Cansado de las pantallas? +1,500 padres ya encontraron la solución.
        </p>
        <button onClick={scrollToPurchase} className="bg-yellow-300 hover:bg-yellow-200 text-orange-800 font-black px-4 py-1 rounded-full text-xs md:text-sm transition-colors uppercase tracking-wider shadow-sm border-b-2 border-yellow-500 active:border-b-0 active:translate-y-[2px]" data-id="element-339">
          ¡Ver Descuento!
        </button>
      </div>
    </div>;
}